export const API_CONFIG_PROD = "prod"; 
export const API_CONFIG_TESTSITE = "testsite"; 
export const API_CONFIG_LOCAL = "local";

export const REDUX_SLICE_STATUS_LOADING = "loading"; 
export const REDUX_SLICE_STATUS_IDLE = "idle"; 